import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'account-sidebar',
    templateUrl: './account.sidebar.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSidebarComponent implements OnInit {
    public loading = false;
    public client: ClientModel = new ClientModel;
    public hasMemberGetMember = false;
    public hasPoints = false;

    constructor(
        protected auth: OauthService,
        protected activatedRoute: ActivatedRoute
    ) {
        this.auth.loadingAuthenticatedUser$.subscribe(_ => {
            this.loading = true;
        });
        this.auth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.loading = true;
            this.client = client;
        });
    }

    ngOnInit() {
        this.handleApps(this.activatedRoute.snapshot.data);
        this.handleStoreConfigurations(this.activatedRoute.snapshot.data);
    }

    private handleApps(data) {
        const hasApps = data['apps'] !== undefined;
        if (!hasApps) {
            return;
        }

        const apps = data['apps'];
        this.hasMemberGetMember = !!(apps['member-get-member'] || false);
    }

    private handleStoreConfigurations(data) {
        const configurations = data['storeConfigurations'];
        if (configurations === undefined) {
            return;
        }

        this.hasPoints = !!(+configurations['points-program-enabled'] || false);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/sidebar/account.sidebar.component.ts